import React, { useState } from "react";
import {Grid, Switch, Modal, Box} from "@mui/material";
import MultiSelectAll from "./MultiSelectAll";
import '../../styles/custom.css';
import {useFilterDataContext} from "../Context/FilterDataContext";

const SelectDropdown = ({title, defaultData, toggle, autocompleteWidth, isActive, onSwitchChange, currentSelection}) => {
    const {setFilteredData, filteredData} = useFilterDataContext();
    const initialValue = currentSelection;
    const [open, setOpenModal] = React.useState(false);

    const handleSwitchChange = (id, event) => {
        const currentSelection = filteredData[`${title}Data`];
        if (!isActive) {
            const dataLength = currentSelection ? currentSelection[title].length : 0;
            if (dataLength !== 2) {
                setOpenModal(true);
                return;
            }
        }
        onSwitchChange(title);
        setFilteredData(prevData => {
            const { comparisonField, ...remainingData } = prevData;
            
            if (comparisonField === title) {
                return remainingData;
            }

            return {
                ...prevData,
                comparisonField: title
            };
        });
    };

    const handleOpen = () => {
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false);
    };

    const resetSwitch = (title) => {
        if(isActive) onSwitchChange(title);
    };

  return (
    <div className="selectDropdownContainer w-100">
        <span>{title}</span>
        <span style={{float: 'right', display : toggle??'none'}}>
            <Switch className="toggleComp" value={title} size="small" color="warning" 
                onChange={handleSwitchChange.bind(this, {title})} 
                checked={isActive} />
        </span>
        <Grid className="selectDropdown" container flexDirection="column" alignItems="center">
            <Grid item sx={{ p: 2, width:"100%" }}>
                <MultiSelectAll
                sx={{
                    maxheight: "700px",
                    borderColor: "pink"
                }}
                autocompleteWidth={autocompleteWidth}
                items={defaultData}
                title={title}
                value={initialValue}
                onSwitchChange={resetSwitch}
                />
            </Grid>
        </Grid>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >
            <Box className="modalStyle">
                <p>Veuillez sélectionner deux {title.charAt(0).toLowerCase()}{title.slice(1)} !</p>
            </Box>
        </Modal>
        </div>
    );
};

export default SelectDropdown;
